// NOTE: This is a copy and paste of the component defined in the folder
// app/components/FilesAndFoldersHeader. The later is not used be cause it is a
// wrongly generalized component. In order to avoid additional "if/else" cases,
// it is copied and changed to cover the needs of the flow view.
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { fileType } from 'types';
import termOptions from 'constants/termOptions';
import HeaderOptions from 'components/HeaderOptions';
import Search from 'components/Search';
import Button from 'components/Button';
import DropDownMenu from './components/DropDownMenu';

import './style.scss';

const FilesAndFoldersHeader = ({
  modelName,
  sidebarIsOpen,
  searchTerm,
  items,
  getItems,
  onOpenModal,
  exportAll,
  deleteAll,
  createNewTempFile,
  createNewTempFolder,
}) => {
  const termOption = termOptions.flow;

  return (
    <HeaderOptions
      bottomLeftOptions={<span styleName="root-item">Root /</span>}
      modelName={modelName}
      topRightOptions={
        <React.Fragment>
          <Search
            getItems={getItems}
            itemsCount={items.length}
            placeholder={termOption.search}
            searchTerm={searchTerm}
          />

          <Button
            isSmall
            data-test="upload-files-button"
            styleName={cn({ 'has-sidebar': sidebarIsOpen })}
            type="button"
            onClick={onOpenModal}
          >
            <i className={termOptions.flow.buttonClassName} />
            <span>{termOption.create}</span>
          </Button>

          <DropDownMenu
            createNewTempFile={createNewTempFile}
            createNewTempFolder={createNewTempFolder}
            deleteAll={deleteAll}
            exportAll={exportAll}
            items={items}
          />
        </React.Fragment>
      }
    />
  );
};

FilesAndFoldersHeader.propTypes = {
  createNewTempFile: PropTypes.func,
  createNewTempFolder: PropTypes.func,
  deleteAll: PropTypes.func,
  exportAll: PropTypes.func,
  getItems: PropTypes.func,
  items: PropTypes.arrayOf(fileType),
  modelName: PropTypes.string,
  searchTerm: PropTypes.string,
  sidebarIsOpen: PropTypes.bool,
  onOpenModal: PropTypes.func,
};

export default FilesAndFoldersHeader;
